import { useOutletContext } from 'react-router-dom'

import { Features } from 'generated/featureDefinitions'

import FinancialWorkspaceEmployeeCosts from 'modules/finance/components/FinancialWorkspaceEmployeeCosts'
import WithPaywall from 'modules/finance/components/WithPaywall'

const FinancialWorkspaceEmployeeCostsPage = () => {
  const { canSeeFinanceWorkspace } = useOutletContext<{ canSeeFinanceWorkspace: boolean }>()

  return (
    <WithPaywall features={[Features.finance_workspace]}>
      {() => <FinancialWorkspaceEmployeeCosts authorized={canSeeFinanceWorkspace} />}
    </WithPaywall>
  )
}

export default FinancialWorkspaceEmployeeCostsPage
